import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'src/redux-app-hooks';
import AdmiMap from 'src/common/components/AdmiMap';
import { BuildingsDeckLayer } from 'src/features/real-estate/BuildingsDeckLayer';
import { loadBuildings, selectBuildings } from './document-generation-new-document.slice';
import { Building } from 'src/features/real-estate/buildings.dto';

const INITIAL_CENTER: google.maps.LatLngLiteral = { lat: 51.211443266, lng: 6.803755898 };

export default function SelectBuildings() {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();
    const { buildings } = useAppSelector((state) => state.documentGenerationNewDocument);

    const [selectedBuildings, setSelectedBuildings] = useState<Building[]>([]);

    function handleSelectBuildings() {
        console.debug('handleSelectBuildings');
        dispatch(selectBuildings(selectedBuildings));
    }

    function handleCenterChanged(center: google.maps.LatLngLiteral) {
        console.debug('handleCenterChanged', center);
        dispatch(loadBuildings({ location: center, radius: 1000 }));
    }

    function handleBuildingSelectionUpdated(newSelectedBuildings: Building[]) {
        console.debug('handleBuildingSelectionUpdated', newSelectedBuildings);
        setSelectedBuildings(newSelectedBuildings);
    }

    useEffect(() => {
        // Initial center for the map
        handleCenterChanged(INITIAL_CENTER);
    }, []);

    return (
        <>
            <AdmiMap
                defaultCenter={INITIAL_CENTER}
                onCenterChanged={handleCenterChanged}
                layers={[BuildingsDeckLayer(buildings, handleBuildingSelectionUpdated)]}
            />

            <Button variant="contained" onClick={handleSelectBuildings}>
                {t('Next')}
            </Button>
        </>
    );
}
